import * as classNames from "classnames";
import * as React from "react";
import { BottomLeftDashboard } from "../../BottomLeftDashboard/BottomLeftDashboard";
import { BottomRightDashboard } from "../../BottomRight/BottomRightDashboard";
import { EmotionSelector } from "../../EmotionSelector/EmotionSelector";
import * as styles from "../../BottomBar.css";
import Render from "../../../Shared/Render";

export function BottomBarControls({
    isQuickJournalVisible,
    displayLarge,
}: {
    isQuickJournalVisible: boolean;
    displayLarge: boolean;
}) {
    return (
        <div
            className={classNames(styles.controlsContent, {
                [styles.controlsContentHidden]: isQuickJournalVisible,
            })}
        >
            <div className={`${styles.controlsColumn} ${styles.controlsColumnLeft}`}>
                <BottomLeftDashboard />
            </div>
            <div
                className={`${styles.controlsColumn} ${styles.controlsColumnCenter}`}
            >
                <Render
                    id="emotionSelector"
                    withClasses={styles.emotionSelectorFade}
                    when={true}
                >
                    <EmotionSelector />
                </Render>
            </div>
            <div className={`${styles.controlsColumn} ${styles.controlsColumnRight}`}>
                <BottomRightDashboard displayLarge={displayLarge} />
            </div>
        </div>
    );
}
